<script lang="ts" setup>
import giftlyFavIcon from '@consumer/assets/images/favicon.ico'
import { useDefaultTheme } from '@consumer/composables/themes'
import { useIsPdfCapture } from '@consumer/composables/pdfCapture'
import ModalsManager from '@consumer/modules/shared/ModalsManager.vue'
import GFlashManager from '@consumer/modules/shared/GFlashManager.vue'
import TheNavigationProgressBar from '@corp/components/TheNavigationProgressBar.vue'
import ToastsManager from '@consumer/modules/layout/ToastsManager.vue'
import { useAddUsernamePrompt } from '@consumer/composables/useAddUsernamePrompt'

defineOptions({
  inheritAttrs: false,
})

useDefaultTheme()
useAddUsernamePrompt()

const isPdfCapture = useIsPdfCapture()

onMounted(() => {
  document.querySelector('.woot--bubble-holder')?.classList.add('no-screenshot')

  if (isPdfCapture.value) {
    const hideWoot = () => {
      document.querySelectorAll<HTMLElement>(
        '.woot--bubble-holder, .woot-widget-holder',
      ).forEach((el) => {
        el.style.setProperty('display', 'none', 'important')
      })
    }
    hideWoot()
    const observer = new MutationObserver(hideWoot)
    observer.observe(document.body, { childList: true, subtree: true })
  }
})
</script>

<template>
  <Head>
    <title>Giftly</title>
    <link rel="icon" :href="giftlyFavIcon">
  </Head>

  <Suspense>
    <main class="flex flex-col h-full w-full" v-bind="$attrs">
      <slot v-bind="$attrs"/>
    </main>
  </Suspense>

  <ToastsManager/>
  <!--
    Teleport GFlashManager to body so .flash-manager escapes `#app`'s
    `isolation: isolate` stacking context (see consumer/styles/reset.scss)
    and can layer above modals (which HeadlessUI renders outside `#app`).
  -->
  <Teleport to="body">
    <GFlashManager/>
  </Teleport>
  <ModalsManager/>
  <TheNavigationProgressBar/>
</template>

<style lang="scss">
.fullscreen-mobile {
  @media screen and (max-width: 1023px) {
    .recipient-layout-container {
      @apply overflow-y-hidden flex flex-col fixed inset-0;
    }

    .recipient-layout-footer {
      @apply hidden;
    }
  }
}
</style>
